import React from "react";
import { HeadingWrap } from "components/atoms/Auth/Heading/Heading.styles";
import logo from "assets/logoz.png";
import { useNavigate } from "react-router-dom";
const Heading = ({ heading, ColoredText, para, paraColoured }) => {
  const navigate = useNavigate();
  return (
    <HeadingWrap>
      <div className="logo" onClick={(e) => navigate("/")}>
        <img src={logo} alt="logo" />
      </div>
      <h1 className="h1">
        {heading} <span className="ColoredText">{ColoredText}</span>
      </h1>
      {para && <p>{para}</p>}
      {paraColoured && <p className="ColoredText">{paraColoured}</p>}
    </HeadingWrap>
  );
};

export default Heading;
